import styled from 'styled-components6';
import { CarouselContrast } from './CarouselCounts';
import { MediaVariants } from './MediaCarousel';

export const ButtonContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'variant', //remove console warning of invalid prop passed to HTML element
})<{ variant: MediaVariants }>`
    //default hide the buttons for light variant
    visibility: ${({ variant }) =>
        variant === 'light' ? 'hidden' : 'visible'};
    opacity: ${({ variant }) => (variant === 'light' ? '0' : '1')};
    transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;
`;

export const PrevButton = ({
    onButtonClick,
    variant,
}: {
    onButtonClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    variant: MediaVariants;
}): JSX.Element => {
    const backgroundColor = variant === 'light' ? 'white' : CarouselContrast;
    const fill = variant === 'light' ? '#1E1E1E' : 'white';
    return (
        <div
            style={{
                position: 'absolute',
                top: 'calc(50% - 20px)',
                left: '0',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
            onClick={(e) => onButtonClick(e)}
            role="button"
        >
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d_208_9883)">
                    <rect
                        x="4"
                        y="4"
                        width="32"
                        height="32"
                        rx="16"
                        fill={backgroundColor}
                        shapeRendering="geometricPrecision"
                    />
                    <path
                        d="M21.2422 27.0977L14.8086 20.3828C14.6328 20.1719 14.5625 19.9609 14.5625 19.75C14.5625 19.5742 14.6328 19.3633 14.7734 19.1875L21.207 12.4727C21.5234 12.1211 22.0859 12.1211 22.4023 12.4375C22.7539 12.7539 22.7539 13.2812 22.4375 13.6328L16.5664 19.75L22.4727 25.9375C22.7891 26.2539 22.7891 26.8164 22.4375 27.1328C22.1211 27.4492 21.5586 27.4492 21.2422 27.0977Z"
                        fill={fill}
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_d_208_9883"
                        x="0"
                        y="0"
                        width="40"
                        height="40"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_208_9883"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_208_9883"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};

export const NextButton = ({
    onButtonClick,
    variant,
}: {
    onButtonClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    variant: MediaVariants;
}): JSX.Element => {
    const backgroundColor = variant === 'light' ? 'white' : CarouselContrast;
    const fill = variant === 'light' ? '#1E1E1E' : 'white';
    return (
        <div
            style={{
                position: 'absolute',
                top: 'calc(50% - 20px)',
                right: '0',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
            onClick={(e) => onButtonClick(e)}
            role="button"
        >
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d_208_9881)">
                    <rect
                        x="4"
                        y="4"
                        width="32"
                        height="32"
                        rx="16"
                        fill={backgroundColor}
                        shapeRendering="geometricPrecision"
                    />
                    <path
                        d="M17.9727 12.4375L24.4062 19.1523C24.5469 19.3281 24.6523 19.5391 24.6523 19.75C24.6523 19.9609 24.5469 20.1719 24.4062 20.3125L17.9727 27.0273C17.6562 27.3789 17.0938 27.3789 16.7773 27.0625C16.4258 26.7461 16.4258 26.2188 16.7422 25.8672L22.6484 19.7148L16.7422 13.5977C16.4258 13.2812 16.4258 12.7188 16.7773 12.4023C17.0938 12.0859 17.6562 12.0859 17.9727 12.4375Z"
                        fill={fill}
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_d_208_9881"
                        x="0"
                        y="0"
                        width="40"
                        height="40"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_208_9881"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_208_9881"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};
